export default __webpack_public_path__ + "static/pen-bf94ab08d7e667704a6b4b076f557440.png";